<template>
    <div>
        <div class="search-box">
            <p>课程名：</p>
            <a-input class="input-box" v-model="searchFrom.courseName" />
            <p>课程号：</p>
            <a-input class="input-box" v-model="searchFrom.courseCode" />
            <p>状态：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.approvalStatus">
                <a-select-option value="saved">未提交</a-select-option>
                <a-select-option value="commit">未审批</a-select-option>
                <a-select-option value="approved">已审批</a-select-option>
                <a-select-option value="reject">已驳回</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <a-button 
                type="primary" 
                icon="plus" 
                class="right-btn"
                v-if="permissions.indexOf('undergraduate:culture:courseProgram:add')>-1" 
                @click="$router.push('/admin/undergraduate/culture/syllabus/info?type=add')">
                 新增
            </a-button>
        </div>
        <a-table 
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            bordered>
            <template slot="id" slot-scope="text,res">
                <a class="action-btn" @click="$router.push('/admin/undergraduate/culture/syllabus/info?type=look&id='+text)">详情</a>
                <a-divider type="vertical" v-if="permissions.indexOf('undergraduate:culture:courseProgram:approve')>-1&&$store.state.user.orgCode==res.orgCode&&res.approvalStatus=='commit'"/>
                <a 
                    class="action-btn"
                    v-if="permissions.indexOf('undergraduate:culture:courseProgram:approve')>-1&&$store.state.user.orgCode==res.orgCode&&res.approvalStatus=='commit'" 
                    @click="$router.push('/admin/undergraduate/culture/syllabus/info?type=examine&id='+text)">审批</a>
                <a-divider type="vertical" v-if="permissions.indexOf('undergraduate:culture:courseProgram:edit')>-1||res.teacherNo==$store.state.user.userId"/>
                <a 
                    class="action-btn" 
                    v-if="permissions.indexOf('undergraduate:culture:courseProgram:edit')>-1||res.teacherNo==$store.state.user.userId"
                    @click="$router.push('/admin/undergraduate/culture/syllabus/info?type=update&id='+text)">
                    编辑
                </a>
                <a-divider type="vertical" v-if="permissions.indexOf('undergraduate:culture:courseProgram:delete')>-1"/>
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    v-if="permissions.indexOf('undergraduate:culture:courseProgram:delete')>-1"
                    @confirm="remove(text)">
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
    </div>
</template>
<script>
    import { list,del } from '@/baseAPI/undergraduate/culture/syllabus'
    const columns = [
        {
            title: '序号',
            align:'center',
            width:70,
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '课程号',
            dataIndex: 'courseCode',
            align:'center'
        },
        {
            title: '课程名称',
            dataIndex: 'courseName',
            align:'center',
        },
        {
            title: '中/英文',
            dataIndex: 'languageName',
            align:'center'
        },
        {
            title: '负责人',
            dataIndex: 'teacherName',
            align:'center'
        },
        {
            title: '课程所属部门',
            dataIndex: 'orgName',
            align:'center'
        },
        {
            title: '状态',
            dataIndex: 'approvalStatus',
            align:'center',
            customRender: (text) => {
                if(text=='reject'){
                    return { children: '已驳回'};
                }else if(text=='approved'){
                    return { children: '系主任已审批'};
                }else if(text=='commit'){
                    return { children: '未审批'};
                }else{
                    return { children: '未提交'};
                }
            },
        },
        {
          title: '操作',
          dataIndex: 'id',
          scopedSlots: { customRender: 'id' }
        }

    ];
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 1,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    courseName:'',
                    courseCode:'',
                    approvalStatus:'',
                },
                permissions:[],
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            console.log(this.permissions)
            if(typeof this.$route.query.courseCode!='undefined'){
                this.searchFrom.courseName=this.$route.query.courseName;
                this.searchFrom.courseCode=this.$route.query.courseCode;
            }

           this.fetch()
        },
        methods:{
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除课程大纲成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
</style>
